// extracted by mini-css-extract-plugin
export default {"window":"ShowFeaturesWindow_window__ItjnW"};